export const COMPANY_STATUS_COLOR = {
  1: '#3DA967',
  2: '#E03643',
  3: '#EC626D',
  4: '#9C9C9C',
  8: '#D375AE',
  9: '#F58B00',
  10: '#3A414B',
  11: '#C8781A',
  12: '#E8B714',
}
